import { LocaleContext } from "./src/locale/BaseLocaleLoader";
import { LocaleLoader } from "./src/locale/LocaleLoader";
import localize from "./src/locale/localize";
import getDeviceLocale from "./src/locale/getNormalizedDeviceLocale";
import storage from "./src/storage/index";
import { BackButton, Router, Route, Link, Switch, withRouter, Redirect } from "./src/routing/index";
import { recordDiff, isArray, isObject, isString, allAreObjects, encodeObjectToUrl, arrayDifference, dateToInstantISOString, serverFormatDateRegex } from "./src/common";
import Globals from "./src/common/Globals";
import PagingQuery from "./src/graphql/PagingQuery";
import NfcProvider from "./src/nfc/NfcProvider";

export {
  Globals,
  BackButton,
  Router,
  Route,
  Switch,
  Link,
  withRouter,
  Redirect,
  LocaleContext,
  LocaleLoader,
  storage,
  localize,
  isArray,
  isObject,
  isString,
  allAreObjects,
  recordDiff,
  arrayDifference,
  dateToInstantISOString,
  serverFormatDateRegex,
  PagingQuery,
  encodeObjectToUrl,
  NfcProvider,
  getDeviceLocale
};
